import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogSurface,
} from "@fluentui/react-components";
import ASCButton from "../Button";

function DeleteDependencyPopup(props: any) {
  return (
    <Dialog open={props.dependencyDeletePopup}>
      <DialogSurface>
        <DialogBody>
          <h3>{props.dependencymessage}</h3>
          <DialogActions>
            <ASCButton
              shape="rounded"
              className="asc-button-primary"
              appearance="primary"
              onClick={() => props.setDependencyDeletePopup(false)}
              label="Close"
            />
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export default DeleteDependencyPopup;
